export class IndexDividendsWithdrawFilterModel {

    public search: string;
    public indexDividendsInfoId: number;
  }